import React from 'react'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'
import { useCheckout } from 'lib/modules/checkout'
import { CheckMo } from 'lib/modules/checkout/components/PaymentMethods/components/CheckMo'
import { Payeezy } from './components/Payeezy'
import { CommerceHub } from './components/CommerceHub'
import { CommerceHubApplePay } from './components/CommerceHubApplePay'
import { CommerceHubGooglePay } from './components/CommerceHubGooglePay'

export const PaymentMethods = () => {
  const { paymentMethod } = useCheckout()
  const { code } = paymentMethod

  let PaymentMethodComponent

  switch (code) {
    case PAYMENT_METHOD.CHECK_MONEY_ORDER: {
      PaymentMethodComponent = CheckMo
      break
    }
    case PAYMENT_METHOD.PAYEEZY: {
      PaymentMethodComponent = Payeezy
      break
    }
    case PAYMENT_METHOD.COMMERCE_HUB: {
      PaymentMethodComponent = CommerceHub
      break
    }
    case PAYMENT_METHOD.COMMERCE_HUB_APPLE_PAY: {
      PaymentMethodComponent = CommerceHubApplePay
      break
    }
    case PAYMENT_METHOD.COMMERCE_HUB_GOOGLE_PAY: {
      PaymentMethodComponent = CommerceHubGooglePay
      break
    }
    default: {
    }
  }

  return PaymentMethodComponent ? <PaymentMethodComponent key={code} /> : null
}
